import axios from 'axios';
import moment from 'moment';
import MitKeyTypeService from './MitKeyTypeService.js';

class MitKeysService {
  constructor() {
      this.keyTypesService = new MitKeyTypeService();
      this.KEY_TYPES = this.keyTypesService.KEY_TYPES;
      this.KEY_TYPES_DEFAULT = this.KEY_TYPES.change_key;
      this.KEY_TYPES_ARRAY = this.keyTypesService.KEY_TYPES_ARRAY;

  }
  adaptUpdateAccessSpacesDisplay(key){
    const spaceName = [];

    for(let x = 0; x < key.spaces.length; x++){
      spaceName.push(key.spaces[x].mitId)
    }

    key.spacesDisplay = spaceName;
  }
  adaptToUIModel(key){
    key.type = this.KEY_TYPES[key.type];//replace with UI type.

    key.dates_local = {
      //lastEditedDate: moment(key.lastEditedDate).local().fromNow(),
      lastEditedDate: moment(key.lastEditedDate).local().format('MMM DD YYYY'),
      createDate: moment(key.createDate).local().fromNow()
    };
    //create a flat list of names that should NOT be edited, this is just a read only list for display purposes
    this.adaptUpdateAccessSpacesDisplay(key);

    return key;
  }
  adaptToAPIModel(key){
    key.type = key.type.id;
    delete key.dates_local;
    delete key.spacesDisplay

    return key;
  }

  getNewKey(){
    return {
        id:null,
        name:'',
        count:0,
        spaces:[],
        data:{},
        type:this.KEY_TYPES_DEFAULT
      }
  }

  requestGetKeys(options) {
    return new Promise ((resolve, reject) => {
      let url = new URL(window.location.origin+'/api/v1/keys/manager');
      if(options && options.count === 'count')
        url.searchParams.append('countLTE', options.number);
      else if(options && options.count === 'available')
        url.searchParams.append('availLTE', options.number);

      if(options && options.orderBy)
        url.searchParams.append('orderBy', options.orderBy);

      axios.get(url.pathname+url.search)
        .then((response) => {
            let keys = response.data.keys;
            for(let x = 0; x < keys.length; x++){
              keys[x] = this.adaptToUIModel(keys[x]);
            }
            return resolve(keys);
        })
        .catch((error) => {

          if(error.response)
            return reject(error.response.data);

          return reject(error);
        });

    });
  }
  requestGetKeysStats() {
    return new Promise ((resolve, reject) => {

      axios.get('/api/v1/keys/manager/stats')
        .then((response) => {
            return resolve(response.data);
        })
        .catch((error) => {

          if(error.response)
            return reject(error.response.data);

          return reject(error);
        });

    });
  }
  requestGetAvailableKeys() {
    return new Promise ((resolve, reject) => {
      axios.get('/api/v1/keys/manager')
        .then((response) => {
            let keys = response.data.keys;
            let keysNew = [];
            for(let x = 0; x < keys.length; x++){
              if (Number(keys[x].numberAvailable) > 0){
                keysNew.push(this.adaptToUIModel(keys[x]));
              }
            }
            return resolve(keysNew);
        })
        .catch((error) => {

          if(error.response)
            return reject(error.response.data);

          return reject(error);
        });

    });
  }

  requestSaveKey(key) {
    return new Promise ((resolve, reject) => {
      let model = this.adaptToAPIModel(key);

      axios.post('/api/v1/keys/manager/key', model)
        .then((response) => {
            return resolve(response.data);
        })
        .catch((error) => {
          return reject(error.response.data);
        });

    });
  }
  requestSaveAllKeys(keys) {
    return new Promise ((resolve, reject) => {
      for(let x = 0; x < keys.length; x++){
        keys[x] = this.adaptToAPIModel(keys[x]);
      }

      axios.post('/api/v1/keys/admin', keys)
        .then((response) => {
            return resolve(response.data);
        })
        .catch((error) => {
          return reject(error.response.data);
        });

    });
  }
  requestDeleteKey(name) {
    return new Promise ((resolve, reject) => {
      axios.delete('/api/v1/keys/manager/'+name)
        .then((response) => {
            return resolve(response.data);
        })
        .catch((error) => {
          return reject(error.response.data);
        });

    });
  }


}

export default new MitKeysService();
